import { ChangeDetectorRef, Component, forwardRef, Input, OnInit} from '@angular/core';
import {ControlValueAccessor, NG_VALUE_ACCESSOR} from '@angular/forms';
import {Dashboard} from '../../../../../../projects/api/src/dashboard/dashboard.model';
import {DashboardApiService} from '../../../../../../projects/api/src/dashboard/dashboard-api.service';
import {LoaderState} from '../../../components/loading-indicator/loader.enum';
import {tap} from 'rxjs/operators';
import {BehaviorSubject} from 'rxjs';

@Component({
  selector: 'app-dashboard-select',
  templateUrl: './dashboard-select.component.html',
  styleUrls: ['./dashboard-select.component.scss'],
  // changeDetection: ChangeDetectionStrategy.OnPush,
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      multi: true,
      useExisting: forwardRef(() => DashboardSelectComponent),
    }
  ]

})
export class DashboardSelectComponent implements ControlValueAccessor, OnInit {
  public disabled = false;
  @Input() required = false;
// @Input() errorMessage = false;
//   public value: number;
  public dashboards: Dashboard[] = [];
  public dashboard: Dashboard;
  public id: number;
  public state$: BehaviorSubject<LoaderState> = new BehaviorSubject(LoaderState.inactive);
  public loaderState = LoaderState;

  constructor(private dashboardApi: DashboardApiService, private cd: ChangeDetectorRef) {
  }


  ngOnInit(): void {
    this.state$.next(LoaderState.loading);
    this.dashboardApi.getAll()
      .pipe(
        tap(() => this.state$.next(LoaderState.inactive), () => this.state$.next(LoaderState.error))
      )
      .subscribe(dashboards => {
        this.dashboards = dashboards.filter(dash => !dash.hidden || dash.id === this.id);
        this.dashboard = this.dashboards.find(dash => dash.id === this.id);
      });
  }

  public onTouched() {
  }

  public changeSelected(dash: Dashboard) {
    this.dashboard = dash;
    this.writeValue(dash.id);

  }

  writeValue(id: number): void {
    this.id = id;
    this.dashboard = this.dashboards.find(dash => dash.id === id);
    this.onChange(id);
  }

  public onChange(value: number) {
  }

  registerOnChange(fn: any): void {
    this.onChange = fn;
  }

  registerOnTouched(fn: any): void {
    this.onTouched = fn;
  }

  setDisabledState(isDisabled: boolean): void {
    this.disabled = isDisabled;
  }


}
